import { createSlice } from '@reduxjs/toolkit'
import { Toast, config } from '../../../config/config'
import { getProduct } from './thunk'
const initialState = {
    product: [],
    logged: false,
    isError: false,
    isUpdated: false,
    isLoading: false
}

export const productSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {
    },
     extraReducers: (builder) => {
        builder.addCase(getProduct.pending, (state) => {
            state.isLoading = true;
            state.logged = false;
        });
        builder.addCase(getProduct.fulfilled, (state, action) => {
            state.logged = true;
            state.product = action.payload?.data;
            state.isLoading = false;
            Toast.fire({
                icon: 'success',
                title: 'Success!'
              });
        });
        builder.addCase(getProduct.rejected, (state, action) => {
            state.updateProfile = false;
            state.isLoading = false;
            Toast.fire({
                icon: 'error',
                title: 'Invalid email or password!'
              });
        });
    }
})

export const { logout,toastHandler } = productSlice.actions
export default productSlice.reducer
